// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.vero-about {
  font-family: "Montserrat", sans-serif;
  background-color: #f9f9f9;
  color: #333;
  line-height: 1.6;
}

.vero-about__hero {
  position: relative;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 60px;
  background-attachment: fixed; 
}

/* Overlay for better text readability */
.vero-about__hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, 
    rgba(0, 0, 0, 0.7) 0%, 
    rgba(0, 0, 0, 0.5) 50%, 
    rgba(0, 0, 0, 0.3) 100%);
  z-index: 1;
}

.vero-about__hero-content {
  position: relative;
  z-index: 2;
  max-width: 900px;
  padding: 60px 20px;
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.vero-about__hero-title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  margin-bottom: 20px;
  font-weight: 900;
  line-height: 1.1;
  text-shadow: 2px 2px 15px rgba(0, 0, 0, 0.7);
  letter-spacing: -0.5px;
  text-transform: uppercase;
}

.vero-about__hero-subtitle {
  font-size: clamp(1.3rem, 2.5vw, 2rem);
  color: #f8f8f8;
  text-shadow: 1px 1px 10px rgba(0, 0, 0, 0.7);
  font-weight: 400;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.5;
  letter-spacing: 0.5px;
}

/* Main Container */
.vero-about__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 80px;
}

/* Sections */
.vero-about__section {
  margin-bottom: 80px;
}

.vero-about__section--highlight {
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f5ff 100%);
  padding: 60px 40px;
  border-radius: 20px;
  margin: 60px -20px;
  position: relative;
}

.vero-about__section--dark {
  background: linear-gradient(135deg, #1a1a1a 0%, #2c3e50 100%);
  color: white;
  padding: 60px 40px;
  border-radius: 20px;
  margin: 60px -20px;
}

/* Section Titles */
.vero-about__section-title {
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  margin-bottom: 20px;
  font-weight: 700;
  color: #222;
  text-align: center;
  position: relative;
  padding-bottom: 15px;
}

.vero-about__section--dark .vero-about__section-title {
  color: white;
}

.vero-about__section-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #5f17ad, #2575fc);
  border-radius: 2px;
}

.vero-about__section--dark .vero-about__section-title::after {
  background: #ffeb3b;
}

.vero-about__section-subtitle {
  font-size: 1.2rem;
  color: #666;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 40px;
  line-height: 1.6;
}

.vero-about__section--dark .vero-about__section-subtitle {
  color: rgba(255, 255, 255, 0.9);
}

/* Intro Section */
.vero-about__intro {
  text-align: start;
  max-width: 900px;
  margin: 0 auto;
}

.vero-about__lead {
  font-size: 1.3rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 30px;
}

/* Philosophy Section */
.vero-about__philosophy {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 40px;
}

.vero-about__philosophy-item {
  background: white;
  padding: 40px 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  text-align: start;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.vero-about__philosophy-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

.vero-about__philosophy-icon {
  font-size: 3rem;
  color: #5f17ad;
  margin-bottom: 20px;
}

.vero-about__philosophy-item h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  font-weight: 600;
  color: #222;
}

.vero-about__philosophy-item p {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
}

/* Expertise Grid */
.vero-about__expertise-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.vero-about__expertise-card {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  text-align: start;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.vero-about__expertise-card:hover {
  border-color: #5f17ad;
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(95, 23, 173, 0.15);
}

.vero-about__expertise-icon {
  font-size: 2.5rem;
  color: #5f17ad;
  margin-bottom: 20px;
}

.vero-about__expertise-card h3 {
  font-size: 1.4rem;
  margin-bottom: 15px;
  font-weight: 600;
  color: #222;
}

.vero-about__expertise-card p {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.6;
}

/* Industry Focus */
.vero-about__industry-focus {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-top: 40px;
}

.vero-about__industry-item {
  background: white;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
  border-left: 4px solid #5f17ad;
  transition: transform 0.3s ease;
}

.vero-about__industry-item:hover {
  transform: translateX(10px);
}

.vero-about__industry-item h3 {
  font-size: 1.3rem;
  margin-bottom: 10px;
  font-weight: 600;
  color: #222;
}

.vero-about__industry-item p {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.6;
}

/* Differentiators */
.vero-about__differentiators {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.vero-about__differentiator {
  position: relative;
  padding: 30px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.vero-about__differentiator-number {
  font-size: 3rem;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.2);
  margin-bottom: 15px;
  line-height: 1;
}

.vero-about__differentiator h3 {
  font-size: 1.4rem;
  margin-bottom: 15px;
  font-weight: 600;
  color: white;
}

.vero-about__differentiator p {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
}

/* Team & Culture */
.vero-about__team-culture {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  margin-top: 40px;
}

@media (min-width: 768px) {
  .vero-about__team-culture {
    grid-template-columns: 2fr 1fr;
  }
}

.vero-about__culture-text {
  font-size: 1.1rem;
  color: #555;
  line-height: 1.8;
}

.vero-about__culture-text p {
  margin-bottom: 20px;
}

.vero-about__culture-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.vero-about__stat {
  background: white;
  padding: 25px 15px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.vero-about__stat:hover {
  transform: scale(1.05);
}

.vero-about__stat-number {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #5f17ad;
  margin-bottom: 5px;
}

.vero-about__stat-label {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}

/* Call to Action */
.vero-about__cta {
  text-align: center;
  padding: 60px 40px;
  background: linear-gradient(135deg, #5f17ad, #2575fc);
  color: white;
  border-radius: 20px;
  margin-top: 60px;
}

.vero-about__cta h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  font-weight: 700;
}

.vero-about__cta p {
  font-size: 1.1rem;
  max-width: 700px;
  margin: 0 auto 30px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.95);
}

.vero-about__cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.vero-about__cta-btn {
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 180px;
  text-align: center;
}

.vero-about__cta-btn--primary {
  background: white;
  color: #5f17ad;
}

.vero-about__cta-btn--primary:hover {
  background: #f0f0f0;
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.vero-about__cta-btn--secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.vero-about__cta-btn--secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

/* Responsive Design */
@media (max-width: 992px) {
  .vero-about__hero {
    background-attachment: scroll; /* Remove parallax on mobile */
  }
  
  .vero-about__section--highlight,
  .vero-about__section--dark {
    margin: 40px -15px;
    padding: 50px 30px;
  }
  
  .vero-about__philosophy,
  .vero-about__expertise-grid,
  .vero-about__industry-focus,
  .vero-about__differentiators {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 25px;
  }
}

@media (max-width: 768px) {
  .vero-about__hero {
    min-height: 50vh;
  }
  
  .vero-about__hero-title {
    font-size: clamp(2rem, 4vw, 3rem);
  }
  
  .vero-about__hero-subtitle {
    font-size: clamp(1.1rem, 2vw, 1.6rem);
  }
  
  .vero-about__section {
    margin-bottom: 60px;
  }
  
  .vero-about__section--highlight,
  .vero-about__section--dark {
    padding: 40px 25px;
    margin: 40px -10px;
  }
  
  .vero-about__lead {
    font-size: 1.1rem;
  }
  
  .vero-about__philosophy-item {
    padding: 30px 20px;
  }
  
  .vero-about__expertise-card {
    padding: 25px 20px;
  }
  
  .vero-about__cta {
    padding: 50px 30px;
  }
  
  .vero-about__cta h2 {
    font-size: 1.8rem;
  }
  
  .vero-about__cta p {
    font-size: 1rem;
  }
  
  .vero-about__cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .vero-about__cta-btn {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 576px) {
  .vero-about__hero {
    min-height: 45vh;
    margin-bottom: 40px;
  }
  
  .vero-about__container {
    padding: 0 15px 60px;
  }
  
  .vero-about__philosophy,
  .vero-about__expertise-grid,
  .vero-about__industry-focus,
  .vero-about__differentiators,
  .vero-about__culture-stats {
    grid-template-columns: 1fr;
  }
  
  .vero-about__section-title {
    font-size: 1.6rem;
  }
  
  .vero-about__lead {
    font-size: 1rem;
  }
  
  .vero-about__philosophy-icon {
    font-size: 2.5rem;
  }
  
  .vero-about__philosophy-item h3 {
    font-size: 1.3rem;
  }
  
  .vero-about__expertise-icon {
    font-size: 2rem;
  }
  
  .vero-about__expertise-card h3 {
    font-size: 1.2rem;
  }
  
  .vero-about__stat {
    padding: 20px 15px;
  }
  
  .vero-about__stat-number {
    font-size: 1.8rem;
  }
  
  .vero-about__cta {
    padding: 40px 25px;
  }
  
  .vero-about__cta h2 {
    font-size: 1.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/About.css"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;4BAG0B;EAC1B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,6BAA6B,EAAE,8BAA8B;EAC/D;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;;;IAIE,2DAA2D;IAC3D,SAAS;EACX;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;;;IAKE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["\n.vero-about {\n  font-family: \"Montserrat\", sans-serif;\n  background-color: #f9f9f9;\n  color: #333;\n  line-height: 1.6;\n}\n\n.vero-about__hero {\n  position: relative;\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: white;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-bottom: 60px;\n  background-attachment: fixed; \n}\n\n/* Overlay for better text readability */\n.vero-about__hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, \n    rgba(0, 0, 0, 0.7) 0%, \n    rgba(0, 0, 0, 0.5) 50%, \n    rgba(0, 0, 0, 0.3) 100%);\n  z-index: 1;\n}\n\n.vero-about__hero-content {\n  position: relative;\n  z-index: 2;\n  max-width: 900px;\n  padding: 60px 20px;\n  animation: fadeInUp 1s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.vero-about__hero-title {\n  font-size: clamp(2.5rem, 5vw, 4rem);\n  margin-bottom: 20px;\n  font-weight: 900;\n  line-height: 1.1;\n  text-shadow: 2px 2px 15px rgba(0, 0, 0, 0.7);\n  letter-spacing: -0.5px;\n  text-transform: uppercase;\n}\n\n.vero-about__hero-subtitle {\n  font-size: clamp(1.3rem, 2.5vw, 2rem);\n  color: #f8f8f8;\n  text-shadow: 1px 1px 10px rgba(0, 0, 0, 0.7);\n  font-weight: 400;\n  max-width: 700px;\n  margin: 0 auto;\n  line-height: 1.5;\n  letter-spacing: 0.5px;\n}\n\n/* Main Container */\n.vero-about__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px 80px;\n}\n\n/* Sections */\n.vero-about__section {\n  margin-bottom: 80px;\n}\n\n.vero-about__section--highlight {\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f5ff 100%);\n  padding: 60px 40px;\n  border-radius: 20px;\n  margin: 60px -20px;\n  position: relative;\n}\n\n.vero-about__section--dark {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2c3e50 100%);\n  color: white;\n  padding: 60px 40px;\n  border-radius: 20px;\n  margin: 60px -20px;\n}\n\n/* Section Titles */\n.vero-about__section-title {\n  font-size: clamp(1.8rem, 3vw, 2.5rem);\n  margin-bottom: 20px;\n  font-weight: 700;\n  color: #222;\n  text-align: center;\n  position: relative;\n  padding-bottom: 15px;\n}\n\n.vero-about__section--dark .vero-about__section-title {\n  color: white;\n}\n\n.vero-about__section-title::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 4px;\n  background: linear-gradient(90deg, #5f17ad, #2575fc);\n  border-radius: 2px;\n}\n\n.vero-about__section--dark .vero-about__section-title::after {\n  background: #ffeb3b;\n}\n\n.vero-about__section-subtitle {\n  font-size: 1.2rem;\n  color: #666;\n  text-align: center;\n  max-width: 700px;\n  margin: 0 auto 40px;\n  line-height: 1.6;\n}\n\n.vero-about__section--dark .vero-about__section-subtitle {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Intro Section */\n.vero-about__intro {\n  text-align: start;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.vero-about__lead {\n  font-size: 1.3rem;\n  color: #555;\n  line-height: 1.8;\n  margin-bottom: 30px;\n}\n\n/* Philosophy Section */\n.vero-about__philosophy {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 40px;\n  margin-top: 40px;\n}\n\n.vero-about__philosophy-item {\n  background: white;\n  padding: 40px 30px;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  text-align: start;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.vero-about__philosophy-item:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);\n}\n\n.vero-about__philosophy-icon {\n  font-size: 3rem;\n  color: #5f17ad;\n  margin-bottom: 20px;\n}\n\n.vero-about__philosophy-item h3 {\n  font-size: 1.5rem;\n  margin-bottom: 15px;\n  font-weight: 600;\n  color: #222;\n}\n\n.vero-about__philosophy-item p {\n  font-size: 1rem;\n  color: #666;\n  line-height: 1.6;\n}\n\n/* Expertise Grid */\n.vero-about__expertise-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 30px;\n  margin-top: 40px;\n}\n\n.vero-about__expertise-card {\n  background: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n  text-align: start;\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.vero-about__expertise-card:hover {\n  border-color: #5f17ad;\n  transform: translateY(-8px);\n  box-shadow: 0 15px 35px rgba(95, 23, 173, 0.15);\n}\n\n.vero-about__expertise-icon {\n  font-size: 2.5rem;\n  color: #5f17ad;\n  margin-bottom: 20px;\n}\n\n.vero-about__expertise-card h3 {\n  font-size: 1.4rem;\n  margin-bottom: 15px;\n  font-weight: 600;\n  color: #222;\n}\n\n.vero-about__expertise-card p {\n  font-size: 0.95rem;\n  color: #666;\n  line-height: 1.6;\n}\n\n/* Industry Focus */\n.vero-about__industry-focus {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 25px;\n  margin-top: 40px;\n}\n\n.vero-about__industry-item {\n  background: white;\n  padding: 25px;\n  border-radius: 12px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);\n  border-left: 4px solid #5f17ad;\n  transition: transform 0.3s ease;\n}\n\n.vero-about__industry-item:hover {\n  transform: translateX(10px);\n}\n\n.vero-about__industry-item h3 {\n  font-size: 1.3rem;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #222;\n}\n\n.vero-about__industry-item p {\n  font-size: 0.95rem;\n  color: #666;\n  line-height: 1.6;\n}\n\n/* Differentiators */\n.vero-about__differentiators {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 30px;\n  margin-top: 40px;\n}\n\n.vero-about__differentiator {\n  position: relative;\n  padding: 30px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.vero-about__differentiator-number {\n  font-size: 3rem;\n  font-weight: 800;\n  color: rgba(255, 255, 255, 0.2);\n  margin-bottom: 15px;\n  line-height: 1;\n}\n\n.vero-about__differentiator h3 {\n  font-size: 1.4rem;\n  margin-bottom: 15px;\n  font-weight: 600;\n  color: white;\n}\n\n.vero-about__differentiator p {\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.6;\n}\n\n/* Team & Culture */\n.vero-about__team-culture {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 40px;\n  margin-top: 40px;\n}\n\n@media (min-width: 768px) {\n  .vero-about__team-culture {\n    grid-template-columns: 2fr 1fr;\n  }\n}\n\n.vero-about__culture-text {\n  font-size: 1.1rem;\n  color: #555;\n  line-height: 1.8;\n}\n\n.vero-about__culture-text p {\n  margin-bottom: 20px;\n}\n\n.vero-about__culture-stats {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.vero-about__stat {\n  background: white;\n  padding: 25px 15px;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease;\n}\n\n.vero-about__stat:hover {\n  transform: scale(1.05);\n}\n\n.vero-about__stat-number {\n  display: block;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #5f17ad;\n  margin-bottom: 5px;\n}\n\n.vero-about__stat-label {\n  font-size: 0.9rem;\n  color: #666;\n  font-weight: 500;\n}\n\n/* Call to Action */\n.vero-about__cta {\n  text-align: center;\n  padding: 60px 40px;\n  background: linear-gradient(135deg, #5f17ad, #2575fc);\n  color: white;\n  border-radius: 20px;\n  margin-top: 60px;\n}\n\n.vero-about__cta h2 {\n  font-size: 2rem;\n  margin-bottom: 20px;\n  font-weight: 700;\n}\n\n.vero-about__cta p {\n  font-size: 1.1rem;\n  max-width: 700px;\n  margin: 0 auto 30px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.vero-about__cta-buttons {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.vero-about__cta-btn {\n  padding: 15px 30px;\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  min-width: 180px;\n  text-align: center;\n}\n\n.vero-about__cta-btn--primary {\n  background: white;\n  color: #5f17ad;\n}\n\n.vero-about__cta-btn--primary:hover {\n  background: #f0f0f0;\n  transform: translateY(-3px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.vero-about__cta-btn--secondary {\n  background: transparent;\n  color: white;\n  border: 2px solid white;\n}\n\n.vero-about__cta-btn--secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-3px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n/* Responsive Design */\n@media (max-width: 992px) {\n  .vero-about__hero {\n    background-attachment: scroll; /* Remove parallax on mobile */\n  }\n  \n  .vero-about__section--highlight,\n  .vero-about__section--dark {\n    margin: 40px -15px;\n    padding: 50px 30px;\n  }\n  \n  .vero-about__philosophy,\n  .vero-about__expertise-grid,\n  .vero-about__industry-focus,\n  .vero-about__differentiators {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 25px;\n  }\n}\n\n@media (max-width: 768px) {\n  .vero-about__hero {\n    min-height: 50vh;\n  }\n  \n  .vero-about__hero-title {\n    font-size: clamp(2rem, 4vw, 3rem);\n  }\n  \n  .vero-about__hero-subtitle {\n    font-size: clamp(1.1rem, 2vw, 1.6rem);\n  }\n  \n  .vero-about__section {\n    margin-bottom: 60px;\n  }\n  \n  .vero-about__section--highlight,\n  .vero-about__section--dark {\n    padding: 40px 25px;\n    margin: 40px -10px;\n  }\n  \n  .vero-about__lead {\n    font-size: 1.1rem;\n  }\n  \n  .vero-about__philosophy-item {\n    padding: 30px 20px;\n  }\n  \n  .vero-about__expertise-card {\n    padding: 25px 20px;\n  }\n  \n  .vero-about__cta {\n    padding: 50px 30px;\n  }\n  \n  .vero-about__cta h2 {\n    font-size: 1.8rem;\n  }\n  \n  .vero-about__cta p {\n    font-size: 1rem;\n  }\n  \n  .vero-about__cta-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .vero-about__cta-btn {\n    width: 100%;\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 576px) {\n  .vero-about__hero {\n    min-height: 45vh;\n    margin-bottom: 40px;\n  }\n  \n  .vero-about__container {\n    padding: 0 15px 60px;\n  }\n  \n  .vero-about__philosophy,\n  .vero-about__expertise-grid,\n  .vero-about__industry-focus,\n  .vero-about__differentiators,\n  .vero-about__culture-stats {\n    grid-template-columns: 1fr;\n  }\n  \n  .vero-about__section-title {\n    font-size: 1.6rem;\n  }\n  \n  .vero-about__lead {\n    font-size: 1rem;\n  }\n  \n  .vero-about__philosophy-icon {\n    font-size: 2.5rem;\n  }\n  \n  .vero-about__philosophy-item h3 {\n    font-size: 1.3rem;\n  }\n  \n  .vero-about__expertise-icon {\n    font-size: 2rem;\n  }\n  \n  .vero-about__expertise-card h3 {\n    font-size: 1.2rem;\n  }\n  \n  .vero-about__stat {\n    padding: 20px 15px;\n  }\n  \n  .vero-about__stat-number {\n    font-size: 1.8rem;\n  }\n  \n  .vero-about__cta {\n    padding: 40px 25px;\n  }\n  \n  .vero-about__cta h2 {\n    font-size: 1.6rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
